import Vue from 'vue'
import Router from 'vue-router'
import Auth from './lib/auth'

import Login from './views/Login.vue'
import Register from './views/Register.vue'
import Products from './views/Products.vue'
import Product from './views/Product.vue'
import Resellers from './views/Resellers.vue'
import Reseller from './views/Reseller.vue'
import Fluxes from './views/Fluxes.vue'
import Flux from './views/Flux.vue'
import Tags from './views/Tags.vue'
import Tag from './views/Tag.vue'
import Categories from './views/Categories.vue'
import Category from './views/Category.vue'
import Pages from './views/Pages.vue'
import Page from './views/Page.vue'
import Brands from './views/Brands.vue'
import Brand from './views/Brand.vue'
import Configs from './views/Configs.vue'
import Menus from './views/Menus.vue'
import Users from './views/Users.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: '/products'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/products',
      name: 'home',
      component: Products,
      meta: { auth: true }
    },
    {
      path: '/product/:id',
      name: 'product',
      component: Product,
      meta: { auth: true }
    },
    {
      path: '/new-product',
      name: 'new-product',
      component: Product,
      meta: { auth: true }
    },
    {
      path: '/resellers',
      name: 'resellers',
      component: Resellers,
      meta: { auth: true }
    },
    {
      path: '/reseller/:id',
      name: 'reseller',
      component: Reseller,
      meta: { auth: true }
    },
    {
      path: '/new-reseller',
      name: 'new-reseller',
      component: Reseller,
      meta: { auth: true }
    },
    {
      path: '/tags',
      name: 'tags',
      component: Tags,
      meta: { auth: true }
    },
    {
      path: '/tag/:id',
      name: 'tag',
      component: Tag,
      meta: { auth: true }
    },
    {
      path: '/new-tag',
      name: 'new-tag',
      component: Tag,
      meta: { auth: true }
    },
    {
      path: '/categories',
      name: 'categories',
      component: Categories,
      meta: { auth: true }
    },
    {
      path: '/category/:id',
      name: 'category',
      component: Category,
      meta: { auth: true }
    },
    {
      path: '/new-category',
      name: 'new-category',
      component: Category,
      meta: { auth: true }
    },
    {
      path: '/pages',
      name: 'pages',
      component: Pages,
      meta: { auth: true }
    },
    {
      path: '/page/:id',
      name: 'page',
      component: Page,
      meta: { auth: true }
    },
    {
      path: '/new-page',
      name: 'new-page',
      component: Page,
      meta: { auth: true }
    },
    {
      path: '/feeds',
      name: 'feeds',
      component: Fluxes,
      meta: { auth: true }
    },
    {
      path: '/feed/:id',
      name: 'feed',
      component: Flux,
      meta: { auth: true }
    },
    {
      path: '/new-feed',
      name: 'new-feed',
      component: Flux,
      meta: { auth: true }
    },
    {
      path: '/brands',
      name: 'brands',
      component: Brands,
      meta: { auth: true }
    },
    {
      path: '/brand/:id',
      name: 'brand',
      component: Brand,
      meta: { auth: true }
    },
    {
      path: '/new-brand',
      name: 'new-brand',
      component: Brand,
      meta: { auth: true }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: { auth: true }
    },
    {
      path: '/configs',
      name: 'configs',
      component: Configs,
      meta: { auth: true }
    },
    {
      path: '/menu',
      name: 'menu',
      component: Menus,
      meta: { auth: true }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const token = Auth.getToken()
  if (to.matched.some(record => record.meta.auth)) {
    if (token) next()
    else next({ name: 'login' })
  } else if (to.matched.some(record => !record.meta.auth)) {
    if (token) next({ name: 'home' })
    else next()
  } else next()
})

export default router
